import React from 'react';
import {
  Form, Checkbox, Spin, Icon,
} from 'antd';
import {
  Box,
} from '../../shared/components';
import InlineCard from '../components/InlineCard';


export default function ProcesosTab({
  procesos, form, noConformidades,
  onChangeProcesosSeleccionados, procesosSeleccionados,
}) {
  const { getFieldDecorator } = form;
  const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
  let content = '';
  const { listado, loading } = procesos;
  const { seleccionada } = noConformidades;
  let { procedimientos: procesosArray } = seleccionada;
  procesosArray = (typeof (procesosArray) !== 'undefined') ? procesosArray : [];

  if (!Array.isArray(procesosArray)) {
    procesosArray = procesosArray.split(',');
  }

  for (let i = 0; i < procesosArray.length; i += 1) {
    if (procesosArray[i] !== undefined) {
      procesosArray[i] = parseInt(procesosArray[i], 10);
    }
  }

  content = (
    <InlineCard
      headerText="PROCESOS"
      content={(
        <Box px={5} py={3}>
          <Spin indicator={antIcon} spinning={loading} size="large">
            {listado.map(item => (
              <Form.Item key={item.id}>
                {getFieldDecorator(`procesos[${item.id}]`, {
                  initialValue: (procesosArray.indexOf(item.id) >= 0) || (procesosSeleccionados.filter(valor => valor === item.id).length > 0),
                  valuePropName: 'checked',
                })(
                  <Checkbox idProceso={item.id} onChange={e => onChangeProcesosSeleccionados(e)}>{item.nombre}</Checkbox>,
                )}
              </Form.Item>
            ))}
          </Spin>
        </Box>
      )}
    />
  );

  return content;
}
